import "./landing-page-steps.component.scss";

export default {
    template: require('./landing-page-steps.component.html'),
    transclude: true,
    controller: function () {
        'ngInject';
    }
};
